import { Routes, RouterModule } from '@angular/router';

import { AuthPage } from './auth.page';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'tabs',
    component: AuthPage,
    children: [
      {
        path: 'signup',
        children: [
          {
            path: '',
            loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule)
          }
        ]
      },
      {
        path: 'login',
        children: [
          {
            path: '',
            loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
          }
        ]
      },
      {
        path: 'demo',
        children: [
          {
            path: '',
            //loadChildren: './demo/demo.module#DemoPageModule'
            //loadChildren: 'src/app/auth/demo/demo.module#DemoPageModule'
            loadChildren: () => import('./demo/demo.module').then(m => m.DemoPageModule)
          }
        ]
      },
      {
        path: 'training',
        children: [
          {
            path: '',
            loadChildren: () => import('./../home/training/training.module').then(m => m.TrainingPageModule)
          }
        ]
      },
      {
        path: 'tutorial',
        children: [
          {
            path: '',
            loadChildren: () => import('./../auth/tutorial/tutorial.module').then(m => m.TutorialPageModule)
          }
        ]
      },
      {
        path: 'ar',
        children: [
          {
            path: '',
            loadChildren: () => import('./../auth/ar/ar.module').then(m => m.ArPageModule)
          }
        ]
      },
      {
        path: 'red',
        children: [
          {
            path: '',
            loadChildren: () => import('./../auth/red/red.module').then(m => m.RedPageModule)
          }
        ]
      },
      {
        path: 'customexam',
        children: [
          {
            path: '',
            loadChildren: () => import('./../home/customexam/customexam.module').then(m => m.CustomexamPageModule)
          }
        ]
      },
      {
        path: '',
        redirectTo: '/auth/tabs/login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/auth/tabs/login',
    pathMatch: 'full'
  },
  {
    path: 'demo',
    loadChildren: () => import('./demo/demo.module').then(m => m.DemoPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./tutorial/tutorial.module').then(m => m.TutorialPageModule)
  }
  ,
  {
    path: 'ar',
    loadChildren: () => import('./ar/ar.module').then(m => m.ArPageModule)
  },
  {
    path: 'red',
    loadChildren: () => import('./red/red.module').then(m => m.RedPageModule)
  },
  {
    path: 'customexam',
    loadChildren: () => import('./../home/customexam/customexam.module').then(m => m.CustomexamPageModule)
  },
  {
    path: 'ar',
    loadChildren: () => import('./ar/ar.module').then( m => m.ArPageModule)
  },
  {
    path: 'red',
    loadChildren: () => import('./red/red.module').then( m => m.RedPageModule)
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthPageRoutingModule { }
